// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Array<T> {
    paramValues: (param: string) => object[]
    addToStart: (...items: any[]) => any[]
    addToEnd: (...items: any[]) => any[]
}

// eslint-disable-next-line no-extend-native
Array.prototype.paramValues = function (param: string) {
    return this?.map?.(item => item?.[param] ?? item)
}

// eslint-disable-next-line no-extend-native
Array.prototype.addToStart = function (...items: any[]) {
    return this.concat(items);
};

// eslint-disable-next-line no-extend-native
Array.prototype.addToEnd = function (...items: any[]) {
    return items.concat(this);
};
